import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  PLATFORM_ID,
  signal
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-back-to-top",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="back-to-top"
      [class.visible]="visible()"
      (click)="scrollTop()"
      aria-label="Back to top"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  `,
  styleUrl: "./back-to-top.scss"
})
export class BackToTop {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  readonly visible = signal(false);

  constructor() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const onScroll = () => this.visible.set(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    this.destroyRef.onDestroy(() => window.removeEventListener("scroll", onScroll));
  }

  scrollTop(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}
